import React from 'react';

/**
 * Section heading — Graha Prime template-тэй ижил.
 *
 * Бүтэц:
 *   ─── EYEBROW (subheading) ───
 *   GREAT BIG HEADING.
 *   Тайлбар текст…
 *   ─── hr.style-2 ── (2 талд квадраттай шугам) ───
 *
 * @param {string} eyebrow — Section-ы дээр гарах жижиг шошго (uppercase)
 * @param {string} title — Том гарчиг
 * @param {string} description — Дэд тайлбар
 * @param {'center'|'left'} align — Зэрэгцүүлэлт
 * @param {'dark'|'light'} variant — Бараан фондэг (dark) эсвэл цайвар фондэг (light)
 * @param {boolean} divider — hr.style-2 дивaйдер харуулах эсэх
 */
export default function SectionHeading({
    eyebrow,
    title,
    description,
    align = 'center',
    variant = 'light',
    divider = true,
}) {
    const isDark = variant === 'dark';
    const alignCls = align === 'center' ? 'text-center items-center' : 'text-left items-start';

    return (
        <div className={`flex flex-col gap-3 mb-12 lg:mb-16 ${alignCls}`}>
            {/* Eyebrow */}
            {eyebrow && (
                <span
                    className={`inline-block text-xs lg:text-sm font-bold uppercase tracking-[0.3em] ${
                        isDark ? 'text-brand-yellow' : 'text-brand-yellow-dark'
                    }`}
                >
                    {eyebrow}
                </span>
            )}

            {/* Heading (Oswald, uppercase) */}
            {title && (
                <h2
                    className={`font-heading uppercase font-bold leading-[1.05] tracking-tight ${
                        isDark ? 'text-white' : 'text-brand-dark'
                    }`}
                    style={{ fontSize: 'clamp(1.75rem, 1.1rem + 2.5vw, 3.6rem)' }}
                >
                    {title}
                </h2>
            )}

            {/* Description */}
            {description && (
                <p
                    className={`max-w-3xl text-base lg:text-lg leading-relaxed ${
                        isDark ? 'text-white/70' : 'text-brand-gray'
                    } ${align === 'center' ? 'mx-auto' : ''}`}
                >
                    {description}
                </p>
            )}

            {/* hr.style-2 — 2 талд квадраттай divider */}
            {divider && (
                <div
                    className={`relative w-full max-w-2xl mt-5 ${align === 'center' ? 'mx-auto' : ''}`}
                >
                    <div
                        className={`h-0.5 ${isDark ? 'bg-white/30' : 'bg-brand-dark/30'}`}
                    />
                    {/* Зүүн квадрат */}
                    <span
                        className="absolute left-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-brand-yellow"
                        aria-hidden="true"
                    />
                    {/* Баруун квадрат */}
                    <span
                        className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-brand-yellow"
                        aria-hidden="true"
                    />
                </div>
            )}
        </div>
    );
}
